import { AppMetricsAverageWholeTeamAggregateRootMapper } from '../../../../src/infrastructure/mappers/team-metrics/app-metrics-average-app-time-whole-team.aggregate-root.mapper';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetAppMetricsAverageWholeTeamRequestDto } from '../../dtos/team-metrics/get-app-metrics-average-whole-team.request.dto';
import { GetAppMetricsAverageWholeTeamResponseDto } from '../../dtos/team-metrics/get-app-metrics-average-whole-team.response.dto';
import { GetAppMetricsAverageWholeTeamQuery } from '../../queries/team-metrics/get-app-metrics-average-whole-team.query';

export class GetAppMetricsAverageWholeTeamController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAppMetricsAverageWholeTeamQuery,
    protected readonly mapper: AppMetricsAverageWholeTeamAggregateRootMapper
  ) {}

  async get(
    props: GetAppMetricsAverageWholeTeamRequestDto
  ): Promise<GetAppMetricsAverageWholeTeamResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `AppMetricsAverageWholeTeamComponentController.get encountered an error ${error}`
      );
    }
  }
}
